import { DatePicker as WPDatePicker } from '@wordpress/components';

const DatePicker = ({ field, value, ...rest }) => (
    <WPDatePicker
        currentDate={value}
        {...rest}
    />
);

export default DatePicker;